
const sliders = {

init(){

    jQuery( document ).ready(function($) {

        $('.hero-slider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            appendArrows: '.arrows-div',
            prevArrow: '<button class="prev-button dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button dashicons-before dashicons-arrow-right-alt2"></button>'
        })
        $('.hero-slider-images').slick({
            autoplay: true,
            autoplaySpeed: 4000,
        })
        $('.testimonial-slider').slick({
                dots:true,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        dots:false
                    }
                }]
        });

        $('.simple-slider-1').slick({
            slidesToShow: 1,
        })
        $('.simple-slider-2').slick({
            slidesToShow: 2,
        })
        $('.simple-slider-3').slick({
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },

            ]
        })
        $('.simple-slider-4').slick({
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        })
        $('.simple-slider-5').slick({
            slidesToShow: 5,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        })
        $('.simple-slider-6').slick({
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        })


        $('.post-slider-1').slick({
            slidesToShow: 1,
            dots: false,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',

        })
        $('.post-slider-2').slick({
            slidesToShow: 2,
            dots: true,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots:false
                    }
                }]
        })
        $('.post-slider-3').slick({
            dots: false,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            slidesToShow: 4,
            responsive: [
                 {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots:false

                    }
                },


                ]
        })
        $('post-slider-4').slick({
            slidesToShow: 4,
            dots: false,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots:false
                    }
                }]
        })
        $('.post-slider-5').slick({
            slidesToShow: 5,
            dots: false,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots:false
                    }
                }]
        })
        $('.post-slider-6').slick({
            slidesToShow: 6,
            dots: false,
            appendArrows: '.post-arrows',
            prevArrow: '<button class="prev-button absolute dashicons-before dashicons-arrow-left-alt2"></button>',
            nextArrow: '<button class="next-button absolute dashicons-before dashicons-arrow-right-alt2"></button>',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots:false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots:false
                    }
                }]


        })

    })
}


}

export default sliders;